import React, { Suspense } from "react";
import { useSelector } from "react-redux";

const AuthLayout = (props) => {
  const isMenuOpened = useSelector((state) => state.Menu.opened);

  return (
    <div className="auth-layout">
      <div
        className={`body-layout ${
          isMenuOpened ? "sidebar-opened" : "sidebar-collapsed"
        } ${props.classNames}`}
      >
        {props.header}

        <Suspense fallback={<div>Loading...</div>}>{props.children}</Suspense>

        <div className="page-sidebar-style">{props.sidebar || false}</div>

        {props.footer}
      </div>
    </div>
  );
};

export default AuthLayout;
